export default "__VITE_ASSET__C$wDIEYA__"